import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../_ovlclient/src/library/table/tableapi"

export type SYSPortalSettingsType = {}

let columns: { [key in keyof SYSPortalSettingsType]: SYSColumnDef } = {}

export let tblSYSPortalSettings: SYSTableDef = {
  id: "SYSPortalSettings",
  permission: "SYSST",
  database: {
    dbInsertMode: "AutoIdentity",
    dataIdField: "Id",
  },
  server: {
    endpoint: "portalsettings",
  },
  features: {
    add: false,
    delete: false,
    edit: true,
    focusToFirstEditableField: true,
    headerMenu: false,
  },
  columns,
}
